import { useEffect, useState } from 'react';

import { getAllTeamMembers } from 'utils/TeamMemberAPI';
import { TeamMember } from 'types/TeamMember';

export default function useTeamMembers() {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const allTeamMembers = await getAllTeamMembers();

      allTeamMembers.sort((a, b) => (a.order > b.order ? 1 : -1));

      setTeamMembers(allTeamMembers);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return {
    teamMembers,
    isLoading,
  };
}
